import { useEffect } from 'react'

export default function useNestedButtonWarningClickHandler() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') return

    function handleDevClick(event: MouseEvent) {
      const target = event.target as HTMLElement

      if (!target.matches('button button')) {
        return
      }

      const buttonRect = target.getBoundingClientRect()
      const clickX = event.clientX
      const isOutsideButton = clickX > buttonRect.right

      if (isOutsideButton) {
        window.open('http://aussiecommerce.atlassian.net/wiki/spaces/TEC/pages/2412282650/Why+you+shouldn+t+put+a+button+in+a+button', '_blank')
        event.stopPropagation()
      }
    }

    window.addEventListener('click', handleDevClick, { capture: true })
    return () => window.removeEventListener('click', handleDevClick)
  }, [])
}
